import Viewport from 'common/utils/viewport';

export default class VelocityScrollable {
    constructor(element, container, raf) {
        this.element = element;
        this.container = container;
        this.raf = raf;
        this.velocity = 0;
        this.threshold = 300;
        this.maxVelocity = 10;

        this.waitForMovement();
        this.startVelocityDetection();
    }

    waitForMovement() {
        this.raf.call(null, () => {
            this.move(this.velocity);
            this.waitForMovement();
        });
    }

    startVelocityDetection() {
        const viewport = new Viewport();

        this.element.addEventListener(
            'mousemove',
            e => {
                let left = e.clientX;
                let right = this.container.clientWidth - e.clientX;

                if (viewport.inSize(['small'])) {
                    this.velocity = 0;
                } else {
                    this.velocity = this.calculateVelocity(left, right);
                }
            },
            false
        );

        this.element.addEventListener(
            'mouseout',
            e => {
                this.velocity = 0;
            },
            false
        );
    }

    calculateVelocity(left, right) {
        if (left < this.threshold) {
            return (this.threshold - left) / this.threshold * -this.maxVelocity;
        } else if (right < this.threshold) {
            return (this.threshold - right) / this.threshold * this.maxVelocity;
        } else {
            return 0;
        }
    }

    move(offset) {
        this.element.scrollLeft += offset;
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/velocity-scrollable.js